// Module
var code = " <h2>Assignment 1 description</h2> <p>Submit:</p> <ol> <li>Your team</li> <li>Description of project plan</li> </ol> ";
// Exports
export default code;